<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import * as globalEnum from "src/common/global-enum";
import { formatImgUrl } from "src/filter/modules/img";
import printHead from "./../print-head.vue";
import { setInfo1, setInfo2 } from "./config";
import {
  getEnum,
  syncGetEnum
} from "src/components/base-control/modules/base-enum-remote";
const textAlign = "right";
const labelWidth = 90;
@Component({
  name: "print-woolen",
  components: {
    printHead
  }
})
export default class App extends Vue {
  sourceInfo = {};
  info = {
    tableInfo1: {}
  };
  PROTECHNICS_DETAIL() {
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .POST_TECHNICS_PRO_DETAIL_GET({
          id: this.$route.query.id,
          materialCode: this.$route.query.materialCode
        })
        .done(res => {
          resolve(res);
        })
        .fail(err => {
          reject();
        });
    });
  }
  init() {
    let enumList = {};
    syncGetEnum("POST_SPS_SYS_ENUM_URL", { typeCode: "TecDocImg" })
      .then((array) => {
        enumList = array
        return this.PROTECHNICS_DETAIL();
      })
      .then(res => {
        res.data.pattern = res.data.pattern ? res.data.pattern.split(",")
          .map((item) => ({
            comment: item,
            code: item,
          })) : []
        this.sourceInfo = {
          ...res.data,
        };
        let productDemandsList = []
        if(res.data.demandProdList && res.data.demandProdList.length) {
          let demandProdList = res.data.demandProdList.sort((a,b) => a.sizeCode - b.sizeCode)
          let demandGrpup = this.$utils.groupBy(res.data.demandProdList, item => item.colorCode + '/' + item.colorName) 
          productDemandsList.push([null, ...this.$utils.uniq(demandProdList.map(item => item.sizeName))])
          this.$utils.forIn(demandGrpup, (value, key) => {
            productDemandsList.push([key, ...value.map(item => item.originQty)])
          })
        }
        let originDemandsList = []
        if(res.data.demandList && res.data.demandList.length) {
          let demandList = res.data.demandList.sort((a,b) => a.sizeCode - b.sizeCode)
          let demandGrpup = this.$utils.groupBy(res.data.demandList, item => item.colorCode + '/' + item.colorName) 
          originDemandsList.push([null, ...this.$utils.uniq(demandList.map(item => item.sizeName))])
          this.$utils.forIn(demandGrpup, (value, key) => {
            originDemandsList.push([key, ...value.map(item => item.originQty)])
          })
        }
        res.data.originDemandsList = originDemandsList
        res.data.productDemandsList = productDemandsList
        this.info.tableInfo1 = setInfo1.call(this, res.data);
        this.info.tableInfo2 = setInfo2.call(this, res.data, enumList);
      })
      .catch(err => {
      });
  }
  get zoomStyle() {
    const { zoom } = this.$route.query;

    if(zoom  == 70) {
      return {
        fontSize: "10px",
        transform: "scale(0.6)",
        width: "165%",
      }
    } else if (zoom == 85) {
      return {
        fontSize: "10px",
        transform: "scale(0.8)",
        width: "125%",
      }
    } else {
      return {}
    }
  }
  mounted() {
    this.init();
  }
  render(h) {
    return (
      <div class="print-woolen">
        <div class="print-woolen__page">
          <print-head info={this.sourceInfo} isWoollen={true}></print-head>
          <multiline-print info={this.info.tableInfo1}></multiline-print>
        </div>
        <div class="print-woolen__page">
          <print-head info={this.sourceInfo} isWoollen={true}></print-head>
          <multiline-print info={this.info.tableInfo2}></multiline-print>
        </div>
      </div>
    );
  }
}
</script>


<style lang="scss">
@media print {
  .print-woolen__page {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
  }
}
</style>
